import axiosInstance from '../utils/axiosInstance';

const BASE_PATH = '/admin/branch-annual-targets';

export async function listAnnualTargets(params = {}) {
  const response = await axiosInstance.get(BASE_PATH, { params });
  return response.data;
}

export async function bulkSaveAnnualTargets(payload) {
  const response = await axiosInstance.post(`${BASE_PATH}/bulk`, payload);
  return response.data;
}
